import React from "react";

const SortInput = ({
  value,
  onChange,
  label,
  options,
  errorText,
  name,
  defaultDisabledValue,
  isRequired,
  tooltip,
}) => {
  return (
    <div className="flex items-center space-y-1 ">
      <label htmlFor={name} className="text-[#0297B2] font-medium text-lg mr-2">
        {label}
        {isRequired && (
          <span className="text-xs text-gray-500">(required)</span>
        )}
      </label>
      <select
        name={name}
        className={
          "text-sm bg-white border border-[#0297B2] rounded-lg p-2.5 text-[#0297B2] focus:outline-none focus:ring-2 focus:ring-[#0297B2] focus:border-transparent"
        }
        value={value}
        onChange={onChange}
        aria-describedby="tooltip"
      >
        <option defaultValue={""} className="text-gray-200">
          {defaultDisabledValue ? defaultDisabledValue : "Default"}
        </option>

        {options?.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <p id="tooltip" className="text-xs text-gray-500">
        {tooltip}
      </p>
    </div>
  );
};

export default SortInput;
